/**
 * use-home-dashboard.ts
 *
 * Hook per la dashboard operativa (home): cosa richiede attenzione oggi, filtrata per
 * ruolo lato backend. Un solo endpoint (GET /api/Dashboard/home), aggiornato
 * periodicamente perché i conteggi possono cambiare mentre la pagina resta aperta.
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/api';
import { useCacheConfig } from '../contexts/cache-config-context';

export function useHomeDashboard() {
  const { config } = useCacheConfig();

  return useQuery({
    queryKey: ['dashboard', 'home'],
    queryFn: () => dashboardService.getHome(),
    staleTime: config.dashboard,
    gcTime: config.dashboard * 2,
    refetchOnWindowFocus: true,
    refetchInterval: config.dashboard,
    placeholderData: (prev) => prev,
  });
}
